// Geo coordinates (lat/lng) for Phuket areas and Bangkok districts.
// Used to enrich Place / LocalBusiness schemas with `geo` for Local SEO.
// Coordinates are approximate centroids of the named area/district.

export type LatLng = { lat: number; lng: number };

export const PHUKET_AREA_COORDS: Record<string, LatLng> = {
  "patong": { lat: 7.8966, lng: 98.2966 },
  "kata": { lat: 7.8204, lng: 98.2982 },
  "karon": { lat: 7.8466, lng: 98.2945 },
  "rawai": { lat: 7.7757, lng: 98.3263 },
  "kamala": { lat: 7.9525, lng: 98.2826 },
  "surin": { lat: 7.9786, lng: 98.2789 },
  "bang-tao": { lat: 8.0036, lng: 98.2974 },
  "cherngtalay": { lat: 8.0123, lng: 98.3023 },
  "nai-yang": { lat: 8.0884, lng: 98.3008 },
  "mai-khao": { lat: 8.1422, lng: 98.3019 },
  "phuket-old-town": { lat: 7.8839, lng: 98.3884 },
  "talad-yai": { lat: 7.8836, lng: 98.3880 },
  "wichit": { lat: 7.8506, lng: 98.3793 },
  "chalong": { lat: 7.8430, lng: 98.3360 },
  "cape-panwa": { lat: 7.8054, lng: 98.4083 },
  "koh-kaew": { lat: 7.9266, lng: 98.4012 },
  "ao-por": { lat: 8.0617, lng: 98.4290 },
  "boat-lagoon": { lat: 7.9374, lng: 98.3996 },
  "royal-phuket-marina": { lat: 7.9347, lng: 98.4001 },
  "yacht-haven": { lat: 8.1640, lng: 98.3416 },
  "thep-krasattri": { lat: 8.0289, lng: 98.3367 },
  "sakhu": { lat: 8.0998, lng: 98.3025 },
  "pa-khlok": { lat: 8.0497, lng: 98.4082 },
  "koh-naka": { lat: 8.0980, lng: 98.4515 },
};

export const BANGKOK_DISTRICT_COORDS: Record<string, LatLng> = {
  "phra-nakhon": { lat: 13.7563, lng: 100.4986 },
  "dusit": { lat: 13.7770, lng: 100.5180 },
  "pom-prap-sattru-phai": { lat: 13.7530, lng: 100.5120 },
  "samphanthawong": { lat: 13.7398, lng: 100.5128 },
  "bang-rak": { lat: 13.7307, lng: 100.5240 },
  "sathon": { lat: 13.7170, lng: 100.5270 },
  "bang-kho-laem": { lat: 13.6940, lng: 100.5020 },
  "yan-nawa": { lat: 13.6970, lng: 100.5450 },
  "pathum-wan": { lat: 13.7456, lng: 100.5331 },
  "ratchathewi": { lat: 13.7590, lng: 100.5340 },
  "phaya-thai": { lat: 13.7800, lng: 100.5430 },
  "din-daeng": { lat: 13.7700, lng: 100.5530 },
  "khlong-toei": { lat: 13.7166, lng: 100.5586 },
  "watthana": { lat: 13.7400, lng: 100.5840 },
  "chatuchak": { lat: 13.8290, lng: 100.5590 },
  "bang-sue": { lat: 13.8050, lng: 100.5370 },
  "lak-si": { lat: 13.8854, lng: 100.5742 },
  "don-mueang": { lat: 13.9123, lng: 100.5944 },
  "sai-mai": { lat: 13.9080, lng: 100.6580 },
  "bang-khen": { lat: 13.8730, lng: 100.5960 },
  "huai-khwang": { lat: 13.7780, lng: 100.5740 },
  "wang-thonglang": { lat: 13.7800, lng: 100.6030 },
  "lat-phrao": { lat: 13.8050, lng: 100.6080 },
  "bang-na": { lat: 13.6680, lng: 100.6050 },
  "phra-khanong": { lat: 13.7050, lng: 100.6010 },
  "suan-luang": { lat: 13.7350, lng: 100.6440 },
  "prawet": { lat: 13.7160, lng: 100.6900 },
  "lat-krabang": { lat: 13.7220, lng: 100.7770 },
  "khlong-sam-wa": { lat: 13.8580, lng: 100.7090 },
  "min-buri": { lat: 13.8140, lng: 100.7320 },
  "nong-chok": { lat: 13.8560, lng: 100.8620 },
  "khan-na-yao": { lat: 13.8260, lng: 100.6770 },
  "bueng-kum": { lat: 13.7860, lng: 100.6680 },
  "saphan-sung": { lat: 13.7660, lng: 100.6840 },
  "bang-kapi": { lat: 13.7660, lng: 100.6470 },
  "rat-burana": { lat: 13.6820, lng: 100.4990 },
  "thung-khru": { lat: 13.6470, lng: 100.4940 },
  "bang-bon": { lat: 13.6620, lng: 100.4080 },
  "chom-thong": { lat: 13.6920, lng: 100.4830 },
  "thon-buri": { lat: 13.7250, lng: 100.4860 },
  "khlong-san": { lat: 13.7320, lng: 100.5070 },
  "bangkok-yai": { lat: 13.7240, lng: 100.4760 },
  "bangkok-noi": { lat: 13.7610, lng: 100.4720 },
  "bang-phlat": { lat: 13.7920, lng: 100.5050 },
  "taling-chan": { lat: 13.7800, lng: 100.4470 },
  "thawi-watthana": { lat: 13.7770, lng: 100.4080 },
  "phasi-charoen": { lat: 13.7160, lng: 100.4580 },
  "nong-khaem": { lat: 13.7080, lng: 100.3470 },
  "bang-khae": { lat: 13.6960, lng: 100.4090 },
  "bang-khun-thian": { lat: 13.6610, lng: 100.4350 },
};

export function getPhuketAreaCoords(slug: string): LatLng | undefined {
  return PHUKET_AREA_COORDS[slug];
}

export function getBangkokDistrictCoords(slug: string): LatLng | undefined {
  return BANGKOK_DISTRICT_COORDS[slug];
}

// Industrial estate centroid coordinates (Phase 25 — B2B leaf SEO).
// Sourced from OSM / IEAT official addresses.
export const INDUSTRIAL_ESTATE_COORDS: Record<string, LatLng> = {
  "amata-city-chonburi": { lat: 13.4147, lng: 101.0028 },
  "amata-city-rayong": { lat: 12.9667, lng: 101.1500 },
  "wha-eastern-seaboard-1": { lat: 12.9520, lng: 101.1789 },
  "wha-eastern-seaboard-2": { lat: 13.1500, lng: 101.0250 },
  "map-ta-phut": { lat: 12.7090, lng: 101.1530 },
  "laem-chabang": { lat: 13.0827, lng: 100.9056 },
  "pinthong": { lat: 13.1880, lng: 101.0540 },
  "gateway-city": { lat: 13.6500, lng: 101.3833 },
  "rojana-ayutthaya": { lat: 14.3000, lng: 100.6833 },
  "hi-tech-ayutthaya": { lat: 14.2350, lng: 100.6080 },
  "navanakorn": { lat: 14.0833, lng: 100.6333 },
  "bangpoo": { lat: 13.5275, lng: 100.6694 },
  "lat-krabang-ie": { lat: 13.7333, lng: 100.7833 },
  "bangchan": { lat: 13.8167, lng: 100.6917 },
  "rojana-rayong": { lat: 12.9550, lng: 101.1450 },
  "304-industrial-park": { lat: 13.9333, lng: 101.7833 },
};

export function getEstateCoords(slug: string): LatLng | undefined {
  return INDUSTRIAL_ESTATE_COORDS[slug];
}